import * as React from 'react';
import { HTMLProps, ReactNode, useState } from 'react';
import cn from 'classnames';
import './styles/Radio.scss';

function Radio(props: Props) {
  const [focused, setFocusedState] = useState(false);
  const {
    className,
    disabled,
    error,
    value,
    name,
    label,
    checked,
    onChange,
    onFocus,
    onBlur,
    ...restProps
  } = props;

  const classNames = cn('Radio', className, {
    Radio_focused: focused,
    Radio_checked: checked,
    Radio_disabled: disabled,
    Radio_error: !disabled && error
  });
  const inputProps = {
    name,
    value,
    disabled,
    checked,
    onChange,
    onFocus(event) {
      onFocus(event);
      if (event.defaultPrevented) return;
      setFocusedState(true);
    },
    onBlur(event) {
      onBlur(event);
      if (event.defaultPrevented) return;
      setFocusedState(false);
    },
    ...restProps
  };

  return (
    <label className={classNames}>
      <span className="Radio__inputWrapper">
        <input className="Radio__input" type="radio" {...inputProps} />
        <span className="Radio__inputAfter" />
      </span>
      {label && <span className="Radio__label">{label}</span>}
    </label>
  );
}

interface Props extends Omit<HTMLProps<HTMLInputElement>, 'type' | 'label'> {
  error?: boolean;
  label?: ReactNode;
}

Radio.defaultProps = {
  className: '',
  label: '',
  name: '',
  disabled: false,
  checked: false,
  error: false,
  onChange: () => {},
  onBlur() {},
  onFocus() {}
};

export default Radio;
